/**
* Photo Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Photo Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'photo-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      $( '.photo-slider' ).each( function() {
        $( this ).find( '.slider' ).slick( {
          dots: false,
          arrows: true,
          prevArrow: $( this ).find( '.prev-slide' ),
          nextArrow: $( this ).find( '.next-slide' ),
          slidesToShow: 3,
          centerMode: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        } );
      } );

      $( '.photo-slider .slider' ).magnificPopup( {
        delegate: 'a',
        type: 'image',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
          arrowMarkup: `<button title="%title%" type="button" class="dir-%dir% popup-btn flex items-center justify-center mr-4 text-white rounded-full prev-slide h-14 w-14 bg-brand-navy"><svg class="w-4 h-4 transform rotate-180 icon icon-slider-arrow"><use xlink:href="#icon-slider-arrow"></use></svg></button>`,
        },
        image: {
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
          titleSrc: function( item ) {
            return item.el.attr( 'title' );
          },
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'photo-slider', COMPONENT );
} )( app );
